module.exports = __webpack_public_path__ + "static/assets/70f8bee49a78f131d8dc87658809a684.svg";